import axios from 'axios';

const SERVER = process.env.REACT_APP_SERVER;

export const getNewsList = async (category = 'all') => {
    const params = category === 'all' ? undefined : { category };

    return await axios.get(`${SERVER}/api/notice/list`, { params });
};

export const getNewsDetail = async (id) => {
    return await axios.get(`${SERVER}/api/notice/${id}`);
};

export const getImgae = async ()=>{
    return await axios.get(`${SERVER}/api/upload/noticeFiles/`);
}